document.addEventListener("DOMContentLoaded", function () {
  const topicWrappers = document.querySelectorAll(".faq-page__topic-wrapper");
  const topicTitles = document.querySelectorAll(".faq-topic__title");
  const topicLines = document.querySelectorAll(".faq-page__topic__line");
  const scrollOffset = 120; // Offset for better visibility

  // Set the first topic as active on initial load
  if (topicLines.length > 0) {
    topicLines[0].classList.add("faq-page__topic__line--active");
  }

  topicWrappers.forEach((topicWrapper, index) => {
    topicWrapper.addEventListener("click", function () {
      // Remove active class from all topics
      document
        .querySelectorAll(".faq-page__topic__line")
        .forEach((line) =>
          line.classList.remove("faq-page__topic__line--active")
        );

      // Add active class to the clicked topic
      const activeLine = this.querySelector(".faq-page__topic__line");
      activeLine.classList.add("faq-page__topic__line--active");

      // Scroll to the corresponding FAQ section
      if (topicTitles[index]) {
        const targetPosition =
          topicTitles[index].getBoundingClientRect().top +
          window.scrollY -
          scrollOffset;
        window.scrollTo({ top: targetPosition, behavior: "smooth" });
      }
    });
  });
});
